import { getInitialBasePathWithMarketIso } from "src/utils/BasePathTools";

export async function getDataEnv<T>(): Promise<T | any> {
  const url = `${getInitialBasePathWithMarketIso()}/env`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error("Failed to fetch env");
  }
  return await response.json();
}
